var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"border-variant":"danger","header":"Belangrijk","header-border-variant":"danger","header-text-variant":"danger","align":"center"}},[_c('b-card-text',[_vm._v(" "+_vm._s(_vm.message))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }